import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { useAuth } from "../../context/AuthContext";
import Switch from "react-switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

const Header = ({ toggleSidebar }) => {
  const { darkMode, toggleDarkMode } = useTheme();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <nav 
      className="navbar neumorphic py-3 px-4" 
      style={{ 
        background: 'var(--bg-primary)',
        fontFamily: 'Poppins, sans-serif'
      }}>
      <div className="navbar-brand is-flex is-align-items-center">
        <button 
          className="navbar-burger neumorphic is-hidden-desktop mr-4 ml-0" 
          onClick={toggleSidebar}
          style={{ 
            border: 'none', 
            background: 'transparent',
            height: '40px',
            width: '40px',
            borderRadius: '10px',
            padding: '0.5rem',
            float: "left"
          }}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <h1 
          className="title is-4 mb-0" 
          style={{ 
            color: 'var(--accent-primary)',
            fontWeight: '600',
            letterSpacing: '0.5px'
          }}>
          <span className="icon-text">
            <span className="icon mr-2">
              <FontAwesomeIcon icon={faGraduationCap} />
            </span>
            <span>Studizy Admin</span>
          </span>
        </h1>
      </div>
      
      <div className="navbar-end is-hidden-touch">
        <div className="navbar-item">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Switch
              checked={darkMode}
              onChange={toggleDarkMode}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              height={24}
              width={48}
            />
            <span style={{ color: 'var(--text-primary)' }}>Dark mode</span>
            <button
              onClick={handleLogout}
              className="button is-neumorphic ml-4"
              aria-label="logout">
              <span className="icon">
                <FontAwesomeIcon icon={faSignOutAlt} />
              </span>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
